import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Drawer, Button } from "@stonelog/stonelog-design-system";
import machineError from "@assets/imgs/machine-error.svg";
import { toCapitalizeFirstLetterOfEachWord } from "../../../../consumingApi/services/helper";
import {
    getAttachmentOsDetails,
    attachmentSelector,
    resetAttachmentOsDetails
} from "../../../../features/anexos/attachmentSlice";

import ImageGallery from "@components/ImageGallery";
import MiniMap from "./MiniMap";

import * as S from "./styles";

const AttachmentServiceOrderDrawer = ({ open, rowClickedInfos, setOpen }) => {
    const dispatch = useDispatch();

    const {
        getAttachmentOsDetailsData,
        getAttachmentOsDetailsStatus
    } = useSelector(attachmentSelector);

    const hasData = Boolean(
        getAttachmentOsDetailsData && Object.keys(getAttachmentOsDetailsData).length > 0
    );

    const fotos = [
        getAttachmentOsDetailsData?.foto_1,
        getAttachmentOsDetailsData?.foto_2,
        getAttachmentOsDetailsData?.foto_3
    ];

    useEffect(() => {
        if (open && rowClickedInfos?.os) {
            dispatch(getAttachmentOsDetails(rowClickedInfos.os));
        }
    }, [open, rowClickedInfos, dispatch]);

    const onClose = () => {
        setOpen(false);
        dispatch(resetAttachmentOsDetails());
    };

    const renderDrawerContent = () => {
        if (getAttachmentOsDetailsStatus === "pending") {
            return <Drawer.Loading />;
        }

        if (getAttachmentOsDetailsStatus === "rejected") {
            return (
                <Drawer.Response
                    element={<img src={machineError} alt="Erro na requisição" />}
                    message="Ocorreu um erro ao buscar os dados da OS. Tente novamente."
                />
            );
        }

        if (getAttachmentOsDetailsStatus === "fulfilled" && !hasData) {
            return (
                <Drawer.Response
                    element={<img src={machineError} alt="Sem dados" />}
                    message="Não foi possível encontrar os detalhes deste atendimento."
                />
            );
        }

        if (getAttachmentOsDetailsStatus === "fulfilled" && hasData) {
            return (
                <S.AllBodyContainer>
                    <S.BodyTopContainer>
                        <S.BodyTopContent>
                            <p>Grau de parentesco (Recebedor)</p>
                            <span>{toCapitalizeFirstLetterOfEachWord(getAttachmentOsDetailsData.recebedor)}</span>
                        </S.BodyTopContent>

                        <S.BodyTopContent>
                            <p>Nome de quem recebeu</p>
                            <span>{toCapitalizeFirstLetterOfEachWord(getAttachmentOsDetailsData.nome_completo)}</span>
                        </S.BodyTopContent>

                        <S.BodyTopContent>
                            <p>Documento informado</p>
                            <span>{getAttachmentOsDetailsData.num_documento || "-"}</span>
                        </S.BodyTopContent>

                        {getAttachmentOsDetailsData.num_locker && (
                            <S.BodyTopContent>
                                <p>Número do Locker</p>
                                <span>{getAttachmentOsDetailsData.num_locker}</span>
                            </S.BodyTopContent>
                        )}
                    </S.BodyTopContainer>

                    <S.BodyMiddleContainer>
                        <S.BodyMiddleHeader style={{ cursor: 'default' }}>
                            <p style={{ fontSize: "16px", color: "#6A7181" }}>
                                Anexos do Atendimento
                            </p>
                        </S.BodyMiddleHeader>

                        <ImageGallery
                            images={fotos}
                            fileName={`OS-${rowClickedInfos?.os || "anexo"}`}
                        />
                    </S.BodyMiddleContainer>

                    <S.BodyMiddleContainer>
                        <S.BodyMiddleHeader style={{ cursor: 'default' }}>
                            <p style={{ fontSize: "16px", color: "#6A7181" }}>
                                Localização do Atendimento
                            </p>
                        </S.BodyMiddleHeader>
                        <MiniMap data={getAttachmentOsDetailsData} />
                        <div style={{ display: 'flex', gap: '10px', marginTop: '8px', fontWeight: 200 }}>
                            <span>🟢 Origem OS</span>
                            <span>🔵 Baixa Atendimento</span>
                        </div>
                    </S.BodyMiddleContainer>
                </S.AllBodyContainer>
            );
        }

        return null;
    };

    return (
        <>
            <Drawer.Root
                placement="right"
                open={open}
                title={
                    <Drawer.Header
                        title={`Detalhes da OS ${rowClickedInfos?.os || ""}`}
                        date={new Date()}
                    />
                }
                onClose={onClose}
                mask={true}
            >
                <Drawer.Body>
                    {renderDrawerContent()}
                </Drawer.Body>
                <Drawer.Footer>
                    <Button width="100%" height="52px" size="large" onClick={onClose}>
                        Fechar
                    </Button>
                </Drawer.Footer>
            </Drawer.Root>
        </>
    );
};

export default AttachmentServiceOrderDrawer;
